import { styled } from '@mui/material';

export const StyledGoalFormToDoList = styled('ul')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	margin: 0,
	padding: 0,
	flex: 1,
	listStyleType: 'none',
});
